import type { ShippingMethodId, ShippingSettings } from "./types";

/** Fallback when CMS/DB unavailable — mirrors seeded Payload defaults. */
export const DEFAULT_SHIPPING_SETTINGS: ShippingSettings = {
  shippingMethods: [
    {
      methodId: "standard",
      fee: 0,
      transitDaysMin: 5,
      transitDaysMax: 12,
      enabled: true,
    },
    {
      methodId: "express",
      fee: 9.99,
      transitDaysMin: 3,
      transitDaysMax: 7,
      enabled: true,
    },
  ],
  processingDaysMin: 1,
  processingDaysMax: 3,
  returnWindowDays: 30,
  marketTransitOverrides: [
    { market: "UK", transitDaysMin: 5, transitDaysMax: 10 },
    { market: "INTL", transitDaysMin: 7, transitDaysMax: 14 },
  ],
};

export const DEFAULT_SHIPPING_METHOD_ID: ShippingMethodId = "standard";

/** @deprecated Use computeShippingFee with CMS settings */
export const ShippingFee = 0;

/** @deprecated Threshold model removed — Standard is always free */
export const FreeShippingStartValue = 0;
